import React from 'react';
import CMPImage from 'components/global/image';

const ResourceIcon: React.FunctionComponent = () => {
  const src = '/images/resources.png';
  return <CMPImage asset={{ src, alt: 'Character' }} width={16} height={18} />;
};
export default ResourceIcon;
